import { axiosBase } from '$api/config'
import {
  BY_CATEGORY,
  BY_H,
  BY_ITEM_ID,
  BY_PRODUCT_ID,
  BY_TEMPLATE_ID,
  BY_W,
  ENDPOINT_CATEGORIES,
  ENDPOINT_DECORATION_ASSET,
  ENDPOINT_ITEMS,
  ENDPOINT_PRODUCTS,
  ENDPOINT_VARIANTS
} from '$api/endpoints'

const state = {
  categories: null,
  items: null,
  products: null,
  product: null,
  variants: null,
  selectedVariant: null,
  selectedDecoration: null,
  selectedItem: null,
  template: null,
  loading: {
    items: null,
    products: null
  }
}

const mutations = {
  setState (state, payload) {
    let cleanPayload
    if (payload.stateItem === 'products') {
      cleanPayload = payload.data.filter(product => {
        return product.is_available
      })
    } else if (payload.stateItem === 'variants') {
      cleanPayload = payload.data.filter(variant => {
        return variant.is_saleable
      })
    } else {
      cleanPayload = payload.data
    }
    state[payload.stateItem] = cleanPayload
  },

  setSelectedItem (state, payload) {
    if (state.items) {
      let foundItems = state.items.filter(item => {
        return String(item.id) === String(payload)
      })
      if (foundItems.length) {
        state.selectedItem = foundItems[0]
      }
    }
  },

  setLoadingState (state, payload) {
    state.loading[payload.type] = payload.item
  }
}

const actions = {
  getCategories ({commit, state}, payload) {
    axiosBase.get(ENDPOINT_CATEGORIES)
      .then(response => {
        commit('setState', {
          stateItem: 'categories',
          data: response.data.results
        })
      })
      .catch(console.error)
  },

  getAllItems ({commit, state}, payload) {
    axiosBase.get(ENDPOINT_ITEMS)
      .catch(console.error)
      .then(response => {
        commit('setState', {
          stateItem: 'items',
          data: response.data.results
        })
      })
  },

  getItemsByCategory ({commit, state}, payload) {
    commit('setLoadingState', { item: payload, type: 'items' })
    axiosBase.get(ENDPOINT_ITEMS + BY_CATEGORY + payload)
      .catch(console.error)
      .then(response => {
        commit('setState', {
          stateItem: 'items',
          data: response.data.results
        })
        commit('setLoadingState', { item: null, type: 'items' })
      })
  },

  getProductsByItem ({commit, state}, payload) {
    commit('setLoadingState', { item: payload, type: 'products' })
    axiosBase.get(ENDPOINT_PRODUCTS + BY_ITEM_ID + payload)
      .catch(console.error)
      .then(response => {
        commit('setState', {
          stateItem: 'products',
          data: response.data.results
        })
        commit('setSelectedItem', payload)
        commit('setLoadingState', { item: null, type: 'products' })
      })
  },

  getVariantById ({ commit }, payload) {
    axiosBase.get(ENDPOINT_VARIANTS + payload.variantId)
      .catch(console.error)
      .then(response => {
        commit('setState', {
          stateItem: 'selectedVariant',
          data: response.data
        })
        payload.cb()
      })
  },
  getVariantsByProduct ({commit, dispatch, state}, payload) {
    axiosBase.get(ENDPOINT_VARIANTS + BY_PRODUCT_ID + payload.productId)
      .catch(console.error)
      .then(response => {
        commit('setState', {
          stateItem: 'variants',
          data: response.data.results
        })
        dispatch('getDecorationAsset', {
          templateId: response.data.results[0].product.decoration.id,
          w: response.data.results[0].production_width,
          h: response.data.results[0].production_height,
          cb: payload.cb
        })
      })
  },

  getDecorationAsset ({commit, dispatch, state}, payload) {
    const assetUrl = ENDPOINT_DECORATION_ASSET + BY_TEMPLATE_ID + payload.templateId + '&' + BY_W + payload.w + '&' + BY_H + payload.h

    axiosBase.get(assetUrl)
      .catch(console.error)
      .then(response => {
        commit('setState', {
          stateItem: 'selectedDecoration',
          data: response.data.results[0]
        })
        payload.cb()
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions
}

export default module



// WEBPACK FOOTER //
// ./uncommon-client/store/modules/system.js